import CorporateFareIcon from '@mui/icons-material/CorporateFare'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import ScheduleIcon from '@mui/icons-material/Schedule'
import StraightenIcon from '@mui/icons-material/Straighten'
import { ImageField, RecordRepresentation, ReferenceField, TextField } from 'react-admin'

import UnitField from '../UnitField'
import { AdvancedInfoWindow, InfoWindowDivider, HeaderSection } from './AdvancedInfoWindow'
import FieldRow from './FieldRow'
import HubPickUpAndDropOffHoursField from '../HubPickUpAndDropOffHoursField'

const HubsInfoWindowContent = () => (
  <>
    <HeaderSection title={'organisation'} />
    <FieldRow icon={CorporateFareIcon}>
      <ReferenceField reference="organisations" source="organisation_id" />
    </FieldRow>
    <InfoWindowDivider />
    <HeaderSection title={'location'} />
    <FieldRow icon={LocationOnIcon}>
      <TextField source="address.formatted_address" />
    </FieldRow>
    <FieldRow icon={StraightenIcon}>
      <UnitField source="geofencing" unit="m" />
    </FieldRow>
    <InfoWindowDivider />
    <HeaderSection title={'openingHours'} />
    <FieldRow icon={ScheduleIcon}>
      <HubPickUpAndDropOffHoursField
        sx={{
          color: '#111',
          '& .RaDatagrid-headerCell': { color: '#111' },
          '& .RaDatagrid-rowCell': { color: '#111' },
        }}
      />
    </FieldRow>
  </>
)
const HubsInfoWindowHeader = () => (
  <>
    <ReferenceField reference="organisations" source="organisation_id" link={false}>
      <ImageField source="picture" sx={{ '& img': { maxWidth: 50, maxHeight: 30 } }} />
    </ReferenceField>
    <RecordRepresentation />
  </>
)

const HubsInfoWindow = (props) => (
  <AdvancedInfoWindow header={HubsInfoWindowHeader} resource="hubs" {...props}>
    <HubsInfoWindowContent />
  </AdvancedInfoWindow>
)

export default HubsInfoWindow
